import {FC} from 'react';
import {Redirect, useParams} from 'wouter';

import {NameView} from '@src/components/name_view';
import {useDb} from '@src/lib/db_store';

interface BrowsePageProps {}

export const BrowsePage: FC<BrowsePageProps> = () => {
  const {key} = useParams();
  const db = useDb(['boy', 'girl']);

  if (key === undefined) {
    return <Redirect to={db ? `/browse/${db[0]?.key}` : '/'} />;
  }

  return <NameView db={db} nameKey={key} backPath="/" navPathPrefix="/browse/" />;
};

BrowsePage.displayName = 'BrowsePage';
